import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import useContentfulAwards from '../contentfulAwards';

const AwardsCarousel = () => {
    const images = useContentfulAwards();

    if (!images || !images.length) {
        return <div>Loading...</div>;
    }

    // Split the images into groups of 5
    const imageGroups = [];
    for (let i = 0; i < images.length; i += 5) {
        imageGroups.push(images.slice(i, i + 5));
    }

    return (
        <Carousel 
            showThumbs={false} 
            showIndicators={false} 
            autoPlay={true} 
            infiniteLoop={true}
            interval={5000}
            transitionTime={1000}
            showArrows={false}
            showStatus={false}
        >
            {imageGroups.map((group, groupIndex) => (
                <div key={groupIndex}>
                    {group.map((url, index) => (
                        <img 
                            key={index} 
                            src={url} 
                            alt="Award"
                            style={groupIndex === 0 && (index === 7 || index === 8) ? { marginTop: '-30px' } : {}}
                            />
                    ))}
                </div>
            ))}
        </Carousel>
    );
};

export default AwardsCarousel;